import { useSetAtom } from "lib/global-context";
import { currentStepAtom, userIdAtom } from "lib/atoms";
import { getUserId } from "lib/api";
import { Pages } from "types/common";
import { getGTMProps } from "types/common";
import { trackSubmission } from "./GTMProvider";
import styles from "./landing-section.module.css";
import { Button } from "components/ui/button";

interface LandingSectionProps {
  page: Pages;
  imageSrc: string;
  headline: string;
  subheading?: string;
  body: string[];
  buttonText?: string;
  note?: string;
}

const LandingSection: React.FC<LandingSectionProps> = ({
  page,
  imageSrc,
  headline,
  subheading,
  body,
  buttonText = "Get started",
  note,
}) => {
  const setCurrentStep = useSetAtom(currentStepAtom);
  const setUserId = useSetAtom(userIdAtom);
  const gtmProps = getGTMProps(page);

  const handleStartClick = async (page: Pages) => {
    setCurrentStep(1);
    const userId = await getUserId(page);
    setUserId(userId);

    trackSubmission({
      formId: `gcb_${userId}`,
      ...gtmProps,
      label: "start_now",
    });
  };

  return (
    <main className={styles.container}>
      <div className={styles.innerContainer}>
        <div className={styles.imageContainer}>
          <img src={imageSrc} alt="" className={styles.image} />
        </div>
        <div className={styles.textContainer}>
          <div className={styles.spaceY4}>
            <h1 className={styles.headline}>{headline}</h1>
            {subheading && <p className={styles.subheading}>{subheading}</p>}
          </div>
          {body.map((paragraph, index) => (
            <p key={index} className={styles.paragraph}>
              {paragraph}
            </p>
          ))}
          <Button
            className={styles.button}
            onClick={() => handleStartClick(page)}
          >
            {buttonText}
          </Button>
          {note && <p className={styles.note}>{note}</p>}
        </div>
      </div>
    </main>
  );
};

export default LandingSection;
